export default "__VITE_ASSET__09bb1b4f__"